import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalQuestionService} from '../../services/global-question.service';
import {API_PATH, QuestionType, RouterLinks} from '../../../shared/constants';
import {Alert, scrollToItem}  from '../../../shared/utilities';
import { Browser } from '@capacitor/browser';
import { SafeUrl, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare var $: any;
declare function draggableSlider(el: any, options: any): any;
declare const accounting: any;

@Component({
    selector: 'app-claim-transcript',
    templateUrl: './claim-transcript.component.html',
    styleUrls: ['./claim-transcript.component.scss'],
    standalone: false
})
export class ClaimTranscriptComponent implements OnInit, OnDestroy {

  printDoc = false;
  pdfDoc = false;
  policy: any;
  web = environment.cssURL;
  objectKeys = Object.keys;
  policyDetails: any;
  overview: any;
  details: any;
  items: any;
  unInsured: any;
  transcript: any[] = [];
  session_id: string;
  QuestionTypes = QuestionType;
  accounting: any;
  media: any;
  claimDetails: any;
  videoUrl = '';
  qrCodeDownloadLink: any;
  sections: any = [];
  selectedMedia: any;
  footer: any;
  token_id: string;
  device: any;
  previewFileUrl: SafeResourceUrl | null = null;
  private previewObjectUrl: string | null = null;
  private processingAlert: any;
  // relative (no leading slash) so it resolves against <base href> at runtime;
  // bound via [href] since a static href="..." on a stylesheet <link> is
  // treated by Angular's AOT compiler as a build-time resource path.
  printPdfCssHref: SafeResourceUrl;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public questionService: GlobalQuestionService,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
  ) {
    this.printPdfCssHref = this.sanitizer.bypassSecurityTrustResourceUrl('assets/css/print_pdf_v2.css');
    try{
      this.device = JSON.parse(localStorage.getItem('device'));
    }
    catch{}
    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.printDoc = this.router.getCurrentNavigation()?.extras?.state?.print;
      this.pdfDoc = this.router.getCurrentNavigation()?.extras?.state?.pdf;
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log(params)
      if (params?.session_id) {
        this.printDoc = (params?.print === 'true');
        this.pdfDoc = (params?.pdf === 'true');
        this.session_id = params.session_id;
        this.getTrsnacript(params.session_id);
       } 
       else if (params?.tid) {
        this.token_id = params.tid;
        let ip = localStorage.getItem('ip_address');
        let parameters = new Map<string, string>();
        parameters.set('token_id', params?.tid);
        parameters.set('ip_address', ip.toString());
        this.questionService
          .runCommandNew(`getTokenParameters`, parameters)
          .subscribe((response) => {
            if (response[0].value){
              this.session_id = response[0].value;
              this.getTrsnacript(this.session_id);
            }
            else {
              Alert("Oops! Invalid session_id provided", 5000);
              setTimeout(() => {
                this.router.navigate([RouterLinks.PolicyResources]);
              }, 5000);
            }
            
          })
       }
      else { 
        Alert("Oops! Invalid session_id provided", 5000);
        setTimeout(() => {
          this.router.navigate([RouterLinks.PolicyResources]);
        }, 5000);
      
      }

    });

    accounting.settings = {
      currency: {
        symbol: this.policy?.currency, // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
  }
  getTrsnacript(session_id: string): void {
    this.session_id = session_id;
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set("claim_session_id", session_id);
    this.questionService
     .runCommandNew(`getTranscript_claims`, parameters, true)
     .subscribe((transcript: any) => {
        this.transcript = [];
        if (transcript?.length) {
          let data = [];
          if (transcript?.length) {
            transcript.map((i)=>{
              i.forEach(x => {
                  data.push(x)
              });
            })
            this.transcript = data;
            this.overview = this.transcript.filter(x => x?.index === 1)[0];
            let policy = this.transcript.filter(x => x?.index === 2)[0];
            this.details = this.transcript.filter(x => x?.index === 3);
            this.items = this.transcript.filter(x => x?.index === 4);
            this.footer = this.transcript.filter(x => x?.index === 5)[0];
            this.policyDetails = this.convertJsonToKeyValuePair(policy);
          }
        }
        // keep the loader up through print/pdf prep instead of flashing the raw page in between
        if (!this.pdfDoc && !this.printDoc) {
          this.questionService.spinner(false);
        }

        setTimeout(() => {
          this.initDocsNav();
          scrollToItem('main');
          if (this.printDoc) {
            window.print();
            this.questionService.spinner(false);
          }
          if (this.pdfDoc) {
            this.pdfDocument();
          }
        }, 500);
      },
        err => {
          this.questionService.spinner(false);
        });
  }

  initDocsNav(): void {
    var scrollSpy = (function () {
 
      var scrollPos;
      var offset;
      var navTargets;

      function init(nav) {
        

         // offset includes height of fixed nav area
         offset = window.matchMedia('(min-width: 992px)').matches ? $('.breadcrumbs').outerHeight() : $('.layout__sidecol').outerHeight();

         // and add 100px as a threshold
         offset += 100;
      

        // IMPORTANT: clear any previously stored targets
        navTargets = [];

         // store target positions          
         $(nav).first().find('li').each(function () {
            var target = $(this).find('a').attr('href');
            if (target === '#') return;
            if ($(target).length) {

               let targetPos = Math.floor($(target).offset().top - $('.navbar').outerHeight() - offset - 1);
               if (targetPos < 0) targetPos = 0;

               navTargets.push([target, targetPos]);
            }
         });        

         spy(nav);
      }

      function spy(nav) {
         scrollPos = $(window).scrollTop();          

         // check each target against scroll position
         navTargets.forEach(function (id, idx) {

            // if scroll below target
            if (scrollPos > navTargets[idx][1]) {

               // if there is a next target
               if ((idx + 1) < navTargets.length) {

                  // check that scroll pos less than next target
                  if (scrollPos < navTargets[idx + 1][1]) {
                     activate(nav, id[0]);
                  }

                  // else no further targets, can activate
               } else {
                  activate(nav, id[0]);
               }

               // else if target is first item
            } else if (idx == 0) {
               activate(nav, id[0]);
            }

         })
      }

      function activate(nav, id) {

         let $activeLi = $(nav).find('li a[href="' + id + '"]').closest('li');

         // activate current li and remove siblings
         $activeLi.addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');

         // activate parents if exist and deactivate siblings and children
         let $activeParentLi = $activeLi.closest('ul').closest('li');
         $activeParentLi
            .addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');
      }


      return {
         init: init,
         spy: spy
      };
   })();
    scrollSpy.init('#docs-nav, #docs-nav-mobile');
    $(window).on('scroll.spy', function () { scrollSpy.spy('#docs-nav, #docs-nav-mobile'); });
    $(window).on('resize.spy', function () { scrollSpy.init('#docs-nav, #docs-nav-mobile'); });

    // activate/deactive nav
    $('.central-nav__list li.has-sub > a').on('click', function (e) {
       e.preventDefault();
       $(this).parent('li').toggleClass('is-active')
          .siblings('li').removeClass('is-active');
    });

 }
 initGallery(): void {

    function initGallerySlider($gallerySlider, itemIndex) {
      // init slider
      $gallerySlider.slick('unslick');
      $gallerySlider.not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          fade: true,
          speed: 250,
          rows: 0,
          adaptiveHeight: true
      });

      // set active item
      $gallerySlider.slick('slickGoTo', itemIndex);

  }


   $('.modal--transcript-gallery').each(function (i) {
     let $modal = $(this);
     let $gallerySlider = $modal.find('.slider--gallery');

     $(this).on('shown.bs.modal', function (e) {
      console.log("here")
       // if e.relatedTarget not available, it means modal was opened via query string script
       if (!e.relatedTarget) {
        console.log("stop")
         initGallerySlider($gallerySlider, 0);
         return;
       }

       // get index of clicked item
       const index = $(e.relatedTarget).index();
       console.log($gallerySlider);
       $gallerySlider.unslick();
       $gallerySlider.not('.slick-initialized').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         dots: false,
         fade: true,
         speed: 250,
         rows: 0,
         adaptiveHeight: true
       });


       // set active item
       $gallerySlider.slick('slickGoTo', index);
     });
   });

  $(document).on('click', '.gallery-slider__item', function () {
    const index = $(this).index();
    const $gallerySlider = $(this).closest('.modal--transcript-gallery').find('.slider--gallery');
    console.log($gallerySlider)
    $gallerySlider.slick('slickGoTo', index);
});

const gallerySliderThumbList = document.querySelectorAll('.gallery-slider');

// loop through each slider
for (let i = 0; i < gallerySliderThumbList.length; i++) {
    draggableSlider(
        gallerySliderThumbList[i],
        function (dragging: any) {
            dragging ? gallerySliderThumbList[i].classList.add('is-dragging') : gallerySliderThumbList[i].classList.remove('is-dragging');
        }
    );
}


 }
 isCurrency(question_type_id: number): boolean{
  let types = [78,79];
  return types.includes(question_type_id);
 }
  getSections(): any {
    const sections = [];
    if (this.items?.length) {
      for (const el of this.items) {
        if (!sections?.some(x => x === el?.section) && el?.section) {
          sections.push(el?.section);
        }
      }
    }
    return sections;
  }
  getClasses(): any {
    const classes = [];
    if (this.transcript?.length) {
      for (const el of this.transcript) {
        if (!classes?.some(x => x === el?.class_name) && el?.class_name) {
          classes.push(el?.class_name);
        }
      }
    }
    return classes;
  }
  getItemsByClass(class_name: string): any {
    const items = [];
    if (this.items?.length) {
      for (const el of this.items) {
        if (el?.class_name === class_name && el?.item_id && !items?.some(x => x.item_id === el.item_id)) {
          items.push(el);
        }
      }
    }
    return items;
  }
 

  getItems(section: string, item_id: string, question_id: number): any[] {
    if (this.transcript?.length) {
      let items = this.transcript?.filter(item => item?.section === section && item?.item_id === item_id && item?.question_id === question_id);
      return items;
    } else {
      return [];
    }
  }

  getBenefits(): any[] {
    if (this.transcript?.length) {
      return this.transcript?.filter(x => x?.vaps_id && x?.vaps_name);
    } else {
      return [];
    }
  }
  
  getResourceImage(answer: any): any[] {
    const response = [];
    if (answer) {
      try {
        const parsed_answer = JSON.parse(answer);
        if (parsed_answer?.length) {
          for (const item of parsed_answer) {
            response.push(`${API_PATH.UPLOAD_RESOURCE}/${item?.resource_id}`);
          }
        }
      } catch {
        //console.warn('not json')
        if (!answer.includes('http')){
          response.push(`${API_PATH.UPLOAD_RESOURCE}/${answer}`);
        }
        else {
          response.push(answer);
        }
        
      }
    }
    return response;
  }
  parseJSON(x: any): any {
    try{
      return JSON.parse(x?.answer);
    }
    catch{
      return [];
    }
    
  }
  showMedia(media: any, selected: any = null): void {
    console.log(media, selected);
    this.media = media;
    if (selected){
      console.log(selected)
      this.selectedMedia = selected;
    }
    //$('#guid-6cfa3bbe').modal('show');
    
    // setTimeout(() => {
    //   const gallerySliderThumbList = document.querySelectorAll('.gallery-slider');
    //   let isDragging = false;
    //   // loop through each slider
    //   for (let i = 0; i < gallerySliderThumbList.length; i++) {
    //     draggableSlider(
    //       gallerySliderThumbList[i],
    //       function (dragging: any) {
    //         dragging ? gallerySliderThumbList[i].classList.add('is-dragging') : gallerySliderThumbList[i].classList.remove('is-dragging');
    //         isDragging = dragging;
    //       }
    //     );
    //   }
    // }, 2000);
  }
  setMedia(media: any): void {
    this.selectedMedia = media;
    console.log(this.selectedMedia)
    $('.slider__slide').hide().fadeIn() ;
  }
  getVideo(item: any): any {
    let url = `${API_PATH.UPLOAD_RESOURCE}/${item.azure_fullname}`;
    return url;
  }
  showVideo(item: any): void{
    $('#media-modal').modal('show');
    this.media = item;
    this.videoUrl = `${API_PATH.UPLOAD_RESOURCE}/${item.azure_fullname}`;
  }
  toTitleCase(val: string): string {
    return val.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
  }
  getLink(item: any): string {
    const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    if (validExtensions.includes(item?.extension)) {
      return item.answer;
    }

    else {
      return `assets/icn/documents/${item?.extension?.replace('.', '')}.svg`;
    }
   
  }
  isImage(item: any): boolean {
    const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    if (validExtensions.includes(item?.extension)) {
      return true;
    }
    else {
      return false;
    }
  }
  isVideo(item: any): boolean {
    const validExtensions = ['.mov', '.mp4', '.avi', '.webm', '.wmv'];
    if (validExtensions.includes(item?.extension)) {
      return true;
    }
    else {
      return false;
    }
  }
  checkIfResource(item: any): boolean {
    try{
      if (item.extension){
        return true;
      }
      else{
        return false;
      }
    }
    catch {
      return false
    }
    
  }
  getGrouping(section: string, q: number): any {
    let groups = [];
    for (const el of this.transcript) {
      if (!groups?.some(x => x === el?.question_group_heading) && el?.section == section && el?.question_id === q) {
        groups.push(el?.question_group_heading);
      }
    }
    return groups;
    //console.log(this.transcript?.filter(item => item?.question_group_heading === x?.question_group_heading));
    //return this.transcript?.filter(item => item?.question_group_heading === x?.question_group_heading);
  }
  getGroupedItems(x: any): any {
    //console.log(this.transcript?.filter(item => item?.question_group_heading === x));
    return this.transcript?.filter(item => item?.question_group_heading === x);
  }
 
  getQuestions(section: string): any {
    const questions = [];
    if (this.transcript?.length) {
      const itemSection = this.transcript?.filter(item => item?.section === section);
      if (itemSection?.length) {
        for (const el of itemSection) {
          if (!questions?.some(x => x === el.question_id)) {
            questions.push(el.question_id);
          }
        }
      }
    }
    return questions;
  }
  getCSS(c: string): string {
    return c?.substring(0, c?.indexOf('.')).toLowerCase();
  }
  onChangeURL(url: any) {
    this.qrCodeDownloadLink = url;
    console.log(url)
  }
  getSectionItems(section: string): any {
    let items: any;
    
      items = this.transcript?.filter(item => item?.section === section);
      let questions = [];
      items.forEach(x => {
        if (!questions.some(y => y.question_id === x.question_id)) {
          questions.push(x);
        }
      });
      questions.forEach(x => {
        let answers = [];
        if (items.filter(y => y.question_id === x.question_id).length > 1) {
          let filtered = items.filter(y => y.question_id === x.question_id);
          filtered.forEach(y => {
            answers.push({"answer": y.answer,"extension": y.extension});
          })
          x.answers = answers;
        }
       
      });
    return questions
  }
  getItemQuestions(i: any, c: any): any {
    let items: any;
    
      items = this.items.filter(x => x.item_id === i.item_id && x.class_name === c)
      let questions = [];
      items.forEach(x => {
        if (!questions.some(y => y.question_id === x.question_id)) {
          questions.push(x);
        }
      });
      questions.forEach(x => {
        let answers = [];
        if (items.filter(y => y.question_id === x.question_id).length > 1) {
          let filtered = items.filter(y => y.question_id === x.question_id);
          filtered.forEach(y => {
            answers.push({"answer": y.answer,"extension": y.extension});
          })
          x.answers = answers;
        }
       
      });
      
    return questions
    //return this.items.filter(x => x.item_id === i.item_id && x.class_name === c);
  }
  convertJsonToKeyValuePair(json: any): { key: string, value: any }[] {
    const keyValuePairs: { key: string, value: any }[] = [];
  
    if (json && typeof json === 'object') {
      for (const key in json) {
        if (json.hasOwnProperty(key)) {
          keyValuePairs.push({ key, value: json[key] });
        }
      }
    } else {
      console.warn('Invalid JSON input provided');
    }
  
    return keyValuePairs;
  }
  pdfDocument(): void{
    this.questionService.spinner(true);
    this.pdfDoc = true;
    document.querySelector('body')?.classList.add('page--pdf');
    document.querySelector('body')?.classList.remove('page--pdf-view');
    document.querySelector('body')?.classList.remove('page--central');
    if (this.route.snapshot.queryParamMap.get('headless') === 'true') {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'assets/css/print_pdf_v2.css';
      link.media = 'all';
      document.head.appendChild(link);
      this.questionService.initPDFStuff();
      setTimeout(() => { document.body.dataset['pdfReady'] = 'true'; }, 2000);
      this.questionService.spinner(false);
      return;
    }
  }
  // fires once the print stylesheet the (pdfDoc) @if block just created has actually
  // loaded — calling initPDFStuff() straight after the flag flip races the browser's
  // fetch/parse of that <link>, so heights get measured under the pre-print layout.
  onPrintCssLoaded(): void {
    if (this.route.snapshot.queryParamMap.get('headless') === 'true') return;
    this.questionService.initPDFStuff();
    this.processingAlert = Alert("Processing... please wait", 30000);
    this.questionService.spinner(false);
    const element = document.getElementById('main');
    this.questionService.pdf(element.innerHTML,'',false,0,'','print_pdf_v2', 'bundle_v2').subscribe(resp => {
      const isNative = this.device?.platform && this.device.platform !== 'web';
      if (isNative) {
        Browser.open({ url: resp.toString() });
        this.clearProcessingAlert();
      } else {
        this.openPDFPreview(resp.toString());
      }
    })
  }
  openPDFPreview(url: string): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
    this.httpClient.get(url, { responseType: 'blob' }).subscribe(blob => {
      this.previewObjectUrl = URL.createObjectURL(blob);
      this.previewFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
      $('#modal-pdf-preview').modal('show');
    });
  }
  onPdfIframeLoad(): void {
    this.clearProcessingAlert();
  }
  clearProcessingAlert(): void {
    this.processingAlert?.clear?.();
    this.processingAlert = null;
  }
  ngOnDestroy(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
  }
}
